import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GraduationCap } from "lucide-react";

export const PROFESSIONAL_PROFILES = ["Ingegnere", "Architetto", "Geometra", "Perito Industriale"];

export const emptyParticipant = () => ({
  first_name: "", last_name: "", fiscal_code: "", birth_date: "", birth_place: "",
  email: "", phone: "", company: "", role: "",
  requires_cfp: false, professional_profile: "", professional_province: "",
});

const FIELDS = [
  ["first_name", "Nome *", "text"], ["last_name", "Cognome *", "text"],
  ["fiscal_code", "Codice Fiscale *", "text"], ["birth_date", "Data di nascita *", "date"],
  ["birth_place", "Luogo di nascita *", "text"], ["email", "Email *", "email"],
  ["phone", "Telefono", "tel"], ["company", "Azienda", "text"], ["role", "Mansione", "text"],
];

// Stesse regole di validazione del checkout Partner
export const validateParticipant = (p, allowedProfiles = PROFESSIONAL_PROFILES) => {
  if (!p.first_name?.trim() || !p.last_name?.trim() || !p.email?.trim()
      || !p.fiscal_code?.trim() || !p.birth_date?.trim() || !p.birth_place?.trim()) {
    return "Nome, cognome, email, codice fiscale, data e luogo di nascita sono obbligatori.";
  }
  if (p.requires_cfp) {
    if (!p.professional_profile?.trim()) return "CFP richiesti: seleziona il Profilo professionale.";
    if (!allowedProfiles.includes(p.professional_profile)) return "Profilo professionale non valido.";
    if (!p.professional_province?.trim()) return "CFP richiesti: inserisci la Provincia dell'ordine professionale.";
  }
  return null;
};

export default function ParticipantForm({ value, onChange, cfpEnabled, cfpProfiles = [], testPrefix = "participant" }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="p-4 rounded-xl border border-slate-200 bg-slate-50/60" data-testid={`${testPrefix}-form`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {FIELDS.map(([k, l, t]) => (
          <div key={k}>
            <Label className="text-xs">{l}</Label>
            <Input type={t} value={value[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`${testPrefix}-input-${k}`} />
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 rounded-lg border border-amber-200 bg-amber-50/60">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2 text-sm text-slate-800">
            <GraduationCap className="w-4 h-4 text-amber-600" />
            <span className="font-semibold">Richiede CFP (Crediti Formativi Professionali)</span>
          </div>
          <Switch checked={!!value.requires_cfp} disabled={!cfpEnabled}
            onCheckedChange={(v) => set("requires_cfp", !!v)} data-testid={`${testPrefix}-cfp-switch`} />
        </div>
        {!cfpEnabled && <div className="text-xs text-slate-500 mt-2">Questo corso non prevede il rilascio di CFP.</div>}
        {value.requires_cfp && cfpEnabled && (
          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Profilo professionale *</Label>
              <Select value={value.professional_profile || ""} onValueChange={(v) => set("professional_profile", v)}>
                <SelectTrigger data-testid={`${testPrefix}-cfp-profile`}><SelectValue placeholder="Seleziona profilo" /></SelectTrigger>
                <SelectContent>{cfpProfiles.map((pp) => <SelectItem key={pp} value={pp}>{pp}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Provincia *</Label>
              <Input value={value.professional_province || ""} onChange={(e) => set("professional_province", e.target.value)}
                placeholder="Es. Roma, Milano, RM, MI…" data-testid={`${testPrefix}-cfp-province`} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
